export const h = {
  stat:{
    zcrs:"Número de personas registradas",
    scrs:"Número de personas en la primera carga",
    scje:"Importe de la primera carga",
    yhkbs:"Número de tarjetas bancarias",
    yhkrj:"Entrada de la tarjeta bancaria",
    usdtbs:"Número de bolígrafos usdt",
    usdtrj:"Entrada de oro de usdt",
    cjbs:"Número de bolígrafos de oro",
    cjje:"Monto del pago",
    tdzrs:"Número total de equipos"
  },
	login:{
			login:"Acceso",
			pleaseusername:"por favor ingrese el nombre de usuario",
			pleasepassword:"Por favor, ingrese contraseña",
			checkname:"Por favor ingrese el nombre de usuario correcto",
			checkpass:"La contraseña no puede tener menos de 3 caracteres.",
		},
	navbar:{
		home:"página delantera",
		mycenter:"Centro personal",
		outlogin:"abandonar",
		close:"cierre",
		editLanguage:"idioma de edición",
	},
	vip:{
    ywy:"Vendedor",
		nickname:"Apodo",
		pleasenickname:"Por favor escribe un apodo",
		username:"nombre de usuario",
		pleaseusername:"por favor ingrese el nombre de usuario",
		arealogin:"Área de inicio de sesión",
		pleasearealogin:"Por favor ingresa a tu área de inicio de sesión",
		nationality:"País de ciudadanía",
		pleasenationality:"Por favor seleccione nacionalidad",
		depositstatus:"Estado del depósito",
		pleasedepositstatus:"Por favor seleccione el estado del depósito",
		createtime:"tiempo de creación",
		logintime:"Hora de iniciar sesión",
		startime:"Tiempo de empezar",
		endtime:"Hora de finalización",
		no:"número de serie",
		shangji:"Recomendación directa a superiores.",
		keyongmoney:"Saldo disponible",
		baozhengjing:"margen",
		fudongyingkui:"Pérdidas y ganancias flotantes",
		zicantotal:"Los activos totales",
		yaoqingma:"Código de invitación",
		zongrujing:"deposito total",
		zongchujing:"Retiros totales",
		loginIp:"IP de inicio de sesión",
		zuihoulogin:"última hora de inicio de sesión",
		shoucirujingmoney:"Monto del primer depósito",
		shoucirujingtime:"Hora del primer depósito",
		kaitongtime:"Hora de apertura",
		keyong:"Disponible",
		daoshi:"tutor",
		dongjie:"congelar",
		chujingstate:"Estado de retiro",
		xiajichujingstate:"Estado de retiro de nivel inferior",
		caozuo:"funcionar",
		chakan:"Controlar",
		heji:"total",
		moneytotal:"balance total",
		paixu:"clasificar",
		daochu:"Exportar",
		huiyuanguanli:"Gestión de miembros",
		yonghu:"usuario",
		search:"búsqueda de consultas",
		reset:"reiniciar",
		delete:"borrar",
		kickout:"echar a patadas",
		notlogin:"Sin iniciar sesión",
		editLanguage:"idioma de edición",
		yourujing:"hay un deposito",
		wurujing:"No hay depósito",
    todayreg: "Volumen de registro del día de hoy: ",
    newvipnum: "El número de nuevos miembros VIP que se unen: ",
    juese: "rol",
    xiugaimima: "cambiar contraseña",
    jiumima: "contraseña anterior",
    shurujiumima: "por favor, ingrese su contraseña anterior",
    xinmima: "nueva contraseña",
    shuruxinmima: "por favor, ingrese su nueva contraseña",
    gerenzhongxing: "centro personal",
    yonghuxinxi: "información del usuario",
	remark: "comentario",
	},
	info:{
		home:"pagina de inicio",
		user:"ID de usuario",
		nickname:"Apodo",
		account:"cuenta",
		identity:"número de identificación",
		phone:"número de teléfono",
		nationality:"País de ciudadanía",
		Balance:"Gestión de saldo",
		real:"cuenta real",
		zhongmongy:"balance total",
		keyongmoney:"Saldo disponible",
		jiaoyidongjie:"Transacción congelada",
		shishilirun:"beneficio en tiempo real",
		shishikeyong:"Disponible en tiempo real",
		xunizhanghu:"cuenta virtual",
		churujinguanli:"Gestión de depósitos y retiros",
		chakanzijinjilu:"Ver historial de fondos",
		rujinjilu:"Registro de depósito",
		rujinjine:"Cantidad del depósito",
		jiaoyibishu:"Número de transacciones",
		chujinjilu:"Registros de retiro",
		chujinjine:"Cantidad de retiro",
		jiaoyiguanli:"Gestión de transacciones",
		lishijilu:"registro de historia",
		chakanlishi:"Ver información histórica de transacciones",
		jiaoyishoushu:"lotes comerciales",
		jiaoyiyingkui:"Ganancias y pérdidas comerciales",
		dangqianchicang:"Posición actual",
		chakandangqianchicang:"Ver información de la posición actual",
		dangqianguadan:"Orden pendiente actual",
		chakanguadanliebiao:"Ver lista de pedidos pendientes",
		guadanbishu:"Número de órdenes pendientes",
		yongjinguanli:"Gestión de comisiones",
		duanwei:"rango",
		wu:"ninguno",
		zhishushangji:"Superior inmediato",
		shangjidaili:"agente superior",
		xiajituandui:"equipo subordinado",
		shurudailiname:"Por favor ingrese el nombre del agente",
		chakan:"Controlar",
		fanyongjie:"Monto del reembolso",
		fanyongbishu:"Número de descuentos",
		chakanyongjinjilu:"Ver registros de reembolso",
		chakanyonghuinfo:"Ver detalles del usuario",
		chakanwenjuan:"Ver cuestionario",
		resetpassword:"restablecer la contraseña",
		sendmsg:"enviar mensaje",
		update:"Revisar",
		unbound:"No unido",
		weishiming:"N",
		yishiming:"Y",
		shiming:"realname",
		gendan:"Gestión de documentación",
		gensui:"seguir",
		chakangendan:"Ver registros de pedidos",
		dingdanhao:"número de orden",
		shoudongpay:"recarga manual",
		chakanyongjingjilu:"Ver historial de comisiones",
		xiugaiyonghuxinxi:"Modificar información del usuario",
		queding:"Seguro",
		quxiao:"Cancelar",
		email:"Correo",
		selguoji:"Por favor seleccione nacionalidad",
		sendusermsg:"Enviar mensaje al usuario",
		title:"título",
		shurutitle:"Por favor ingrese el título del mensaje",
		content:"contenido",
		shurucontent:"Por favor ingrese el contenido del mensaje",
		zhenshi:"realidad",
		xuni:"virtual",
		fangxiang:"dirección",
		zhanghu:"Cuenta",
		add:"Aumentar",
		less:"deducir",
		type:"tipo",
		guanliyuanpay:"Recarga de administrador",
		pay:"completar",
		money:"Cantidad",
		updategdmsg:"Modificar información del pedido",
		xinhaoyuan:"fuente de señal",
		yes:"Sí",
		no:"No",
		updateyongjingmsg:"Modificar información de comisiones",
		qingxuanzejuese:"Por favor seleccione el rol de la cuenta",
		zuoduo:"Ve largo",
		zuokong:"corto",
		gensuinicheng:"seguir apodo",
		kaicangjia:"precio de apertura",
		pingcangjia:"Precio de cierre",
		shousu:"Tamaño del lote",
		pingcangdate:"Fecha de apertura del puesto",
		kaicangdate:"fecha de cierre",
		chakangensuiinfo:"Ver detalles de seguimiento",
		gensuiuserno:"Seguir número de usuario",
		gensuiyonghuname:"Seguir el apodo del usuario",
		gensuifangshji:"seguir el método",
		number:"cantidad",
		danwei:"unidad",
		zhengxiang:"adelante",
		fanxaing:"contrarrestar",
		beishu:"múltiple",
		shousu:"Tamaño del lote",
		gensuizhuangtai:"seguir estado",
		genjinzhong:"La aplicación está siguiendo",
		gensuiok:"Aceptar ser seguido",
		gensuino:"Se negó a ser seguido",
		chexiao:"Cancelar",
		gensuidate:"seguir el tiempo",
		chakanlishijiaoyi:"Ver información histórica de transacciones",
		chakanguadanlist:"Ver lista de pedidos pendientes",
		heyue:"contrato",
		daili:"interino",
		huiyuanname:"Nombre de los miembros",
		xianjia:"límite de precio",
		zhisun:"detener la pérdida de",
		guadanjia:"precio de orden pendiente",
		zhiyingzhisun:"Obtenga ganancias y detenga las pérdidas",
		zhiyingjia:"Precio de toma de ganancias",
		zhiyinghuichejia:"Precio de retroceso de toma de ganancias",
		zhisunjia:"Precio de parada de pérdidas",
		zhisunhuichejia:"Precio de retroceso de stop loss",
		weiset:"no establecido",
		zt:"estado",
		chakanchicangmsg:"Ver información de la posición actual",
		shouyiId:"Identificación del beneficiario",
		xiajiid:"ID de usuario subordinado",
		xiajiuser:"Nombre de usuario subordinado",
		fanyongmonney:"Monto del reembolso",
		tuihuibaozhengjing:"Depósito de devolución",
		shouxufei:"tasa de tramitación",
		shouyi:"ingreso",
		lixi:"Interés",
		zengmoney:"prima",
		zhuijiabaozhengjing:"llamada de margen",
		fanyong:"Reembolso",
		rujing:"Depósito",
		chujing:"Retirar Fondos",
		chujingshibai:"Reembolso si falla la revisión de retiro",
		guanliyuanless:"Deducción administrativa",
		pingzhong:"Variedad",
		shengqingzhong:"Aplicando",
		wancheng:"Finalizar",
		chongzhimima:"Restablecimiento de contraseña exitoso",
		copy:"Copiar",
		zhanghaomima:"contraseña de cuenta",
		fenye:"Artículo / Página",
    tixianmima:"Contraseña de retiro de efectivo",
		gong:"común",
		tiao:"banda",
		ye:"Página",
		goto:"Ir a",
		outtitle:"Has cerrado tu sesión. Puedes cancelar y permanecer en esta página o iniciar sesión nuevamente.",
		outok:"Aceptar para cerrar sesión",
		chongxingdenglu:"volver a registrarse",
		cancel:"Cancelar",
		pingtai:"plataforma",
		nodata:"Sin datos",
    shangjiID: "ID Superior",
    shangjiaccount: "Cuenta Superior",
    shangjiname: "Apodo Superior",
    shangjinickname: "Nombre Superior",
    zhongyingkui: "Ganancia y Pérdida Total",
    fuying: "Ganancia Flotante",
    yue: "Saldo",
    sheng: "Orden Ascendente",
    jiang: "Orden Descendente",
    dongjie: "Su cuenta ha sido bloqueada",
    jiedong:"La cuenta se ha descongelado"
	},
	history:{
			guadan:"Ganancia y perdida",
			shijia:"orden pendiente",
			gendan:"precio de mercado",
			dangqianjia:"Seguir las órdenes",
			geyelixi:"precio actual",
			weituodate:"interés nocturno",
			pingcangfangshi:"tiempo de comisión",
			dingdanyongjing:"Método de cierre",
			shoudongpingcang:"Comisión de pedido",
			qiangzhipingcang:"Cierre manual",
			gendanpingcang:"Liquidación forzosa",
			baocang:"Liquidación",
			yuguqiangpingjia:"Seguir órdenes para cerrar una posición",
			kaicangdiqu:"Precio de paridad forzosa estimado",
			ispingcang:"Área de apertura",
			tips:"¿Estás seguro de la liquidación forzosa?",
			pincangsucc:"pista",
			queding:"Posición cerrada con éxito",
			cancel:"Seguro",
		},
	Langswitch: {
	  "en":"Inglés",
	  "id":"indonesio",
	  "th":"Idioma tailandés",
	  "vi":"vietnamita",
	  "zh":"Chino",
	  "fa":"Francés",
	  "han":"coreano",
	  "tu":"turco",
	  "pu":"portugués",
	  "xi":"español",
	  "jp":"japonés",
	  "ar":"Arábica",
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/xi.js